module.exports = __webpack_public_path__ + "img/thesis.ef59f326.png";